/**
 * Activity log: every player's events (player_events) on MAD's six category chips, with a
 * search, a player search and paging, read-only — GET /admin/activity. A row's player opens
 * the player card, whose own ACTIVITY LOG block shows the same feed for that player alone.
 */
import { activityLog } from './activity-log';
import { invoiceFor } from './invoices';
import { openPlayerCard } from './player-card';
import { ADMIN_SECTION_EVENT } from './section-event';
import { panel } from './ui';

export function renderActivity(host: HTMLElement): () => void {
  const log = activityLog({
    onOpenPlayer: (e) => openPlayerCard(e.userId, e.user?.username ?? e.user?.email ?? e.userId, {
      onChanged: () => {},
      // Same hand-off as the Players tab: the Invoices tab opens with the form filled.
      onInvoice: (c) => {
        invoiceFor({ id: c.id, nickname: c.nickname ?? c.username ?? null, email: c.email });
        document.dispatchEvent(new CustomEvent(ADMIN_SECTION_EVENT, { detail: 'invoices' }));
      },
    }),
  });
  host.appendChild(panel('Activity log', log.node));
  return log.stop;
}
